import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner.js';

const DiscountSuggestedSummary = ({ partner, payment }) => {
    let text;
    let body;
    let actionRequiredType;

    if (payment.performedBy === 'BUYER') {
        text = `Varen er ikke som ${partner.name} forventet.`;
        body = `${partner.name} foreslår et prisavslag`;
        actionRequiredType = 'NEGATIVE';
    } else {
        text = `Du har foreslått et prisavslag på ${formatOreToKroner(
            payment.discount
        )}.`;
        body = `Venter på svar fra ${partner.name}`;
    }

    return (
        <StatusSummaryButton
            href="/losning/avslag-foreslatt"
            statusSummary={text}
            actionRequiredType={actionRequiredType}
        >
            {body}
        </StatusSummaryButton>
    );
};

DiscountSuggestedSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

export default DiscountSuggestedSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/resolution/summaries/discountSuggestedSummary.jsx